@let isSmall = small();
@let score = leakScore();

<div class="flex items-baseline gap-[0.375rem]">
  @if (score === undefined || score === null) {
    <span class="font-bold leading-none text-(--p-primary-500)"
      [ngClass]="isSmall ? 'text-[1rem]' : 'text-[1.25rem]'"
      translate="@@shared-no-data-value-placeholder">
    </span>
  } @else {
    <span class="font-bold leading-none text-(--p-primary-500)"
      [ngClass]="isSmall ? 'text-[1rem]' : 'text-[1.25rem]'"
      translate="@@shared-percentage"
      [translateParams]="{I18N_VAR_VALUE: score}">
    </span>
  }

  <span class="text-[0.6875rem] font-[500] text-(--p-primary-500)"
    [ngClass]="{ '!text-[0.625rem]': isSmall }"
    translate="@@shared-ai-predictor__text">
  </span>
</div>

<p-progressbar class="flex flex-1"
  styleClass="!h-[0.375rem] !w-full !max-w-[10.25rem] !min-w-[5.625rem] flex-1 !bg-transparent"
  [style]="{'border-color': progressColor()}"
  [color]="progressColor()"
  [value]="score ?? 0"
  [showValue]="false">
</p-progressbar>
